import type { DomApplier } from '../cssFeatures.types'
import { DEFAULT_VARIANT_KEY, OPACITY_OVERRIDE, RESET_TRANSPARENT, TRANSPARENT_EDIT_STYLE } from './constants'
import { getVariantSelectors } from '../../utils/variantsUtils'

export const componentsVisibilityDomApplier: DomApplier<'componentsVisibility'> = (
	{ id: compId },
	_,
	breakpointId,
	{ componentsVisibility },
	cssContext
) => {
	const opacityInBreakpoint = componentsVisibility?.breakpointToOpacity?.[breakpointId]

	if (!componentsVisibility || typeof opacityInBreakpoint === 'undefined') {
		return {}
	}
	const { isCollapsed, isHidden, transparencyThreshold } = componentsVisibility

	const defaultDomSelector = getVariantSelectors(DEFAULT_VARIANT_KEY, {}, compId, cssContext).join(', ')
	const overlayDomSelector = `${defaultDomSelector}::after`

	const shouldShowTransparentComponentWithOverlay = opacityInBreakpoint <= transparencyThreshold
	if (shouldShowTransparentComponentWithOverlay) {
		return {
			[defaultDomSelector]: { opacity: OPACITY_OVERRIDE },
			...(!(isHidden || isCollapsed) ? { [overlayDomSelector]: TRANSPARENT_EDIT_STYLE } : {}),
		}
	}

	const shouldResetTransparentComponentOverlay = opacityInBreakpoint > transparencyThreshold
	if (shouldResetTransparentComponentOverlay) {
		if (!(isHidden || isCollapsed)) {
			return {
				[defaultDomSelector]: { opacity: opacityInBreakpoint },
				[overlayDomSelector]: RESET_TRANSPARENT,
			}
		}
	}

	return {}
}
